// extracted by mini-css-extract-plugin
export default {"button":"looking-for-smth-different__button___j7pm3","text":"looking-for-smth-different__text___k5DA2"};